/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_Mixed_IntensityInputs */

const en_ui_te_summary_mixed_intensity = /** @type {(inputs: Ui_Te_Summary_Mixed_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixed-intensity session with significant aerobic and anaerobic stimulus.`)
};

const de_ui_te_summary_mixed_intensity = /** @type {(inputs: Ui_Te_Summary_Mixed_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemischte Intensität — deutlich aerob und anaerob gefordert.`)
};

/**
* | output |
* | --- |
* | "Mixed-intensity session with significant aerobic and anaerobic stimulus." |
*
* @param {Ui_Te_Summary_Mixed_IntensityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_mixed_intensity = /** @type {((inputs?: Ui_Te_Summary_Mixed_IntensityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_Mixed_IntensityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_mixed_intensity(inputs)
	return de_ui_te_summary_mixed_intensity(inputs)
});